import api from "./revenuePlannerApi";

const forecast = {
  list: (accessToken, body) => api.post("/forecast", body, accessToken),
  projectList: (accessToken, body) =>
    api.post("/forecast/projects", body, accessToken),
  override: (accessToken, body) =>
    api.post("/forecast/override", body, accessToken),
  overrideListing: (accessToken, body) =>
    api.post("/forecast/override-logs", body, accessToken),
  getStatus: (accessToken, id) =>
    api.get(`/forecast/override/${id}/status`, accessToken),
  getDisaggregationStatus: (accessToken, id) =>
    api.get(`/forecast/override/${id}/disaggregation-status`, accessToken),
  getSearchSyncStatus: (accessToken, id) =>
    api.get(`/forecast/override/${id}/search-sync-status`, accessToken),
};

export default forecast;
